import braintree from 'braintree-web';
import hostedFields from 'braintree-web/hosted-fields';

function createVenmoClient(braintreePK: string): Promise<braintree.Venmo> {
  return new Promise((resolve, reject) => {
    braintree.client
      .create({
        authorization: braintreePK,
      })
      .then((clientInstance) => {
        braintree.venmo
          .create({
            client: clientInstance,
            allowDesktop: true,
            allowDesktopWebLogin: false,
            paymentMethodUsage: 'multi_use', // available in v3.77.0+
            // Add allowNewBrowserTab: false if your checkout page does not support
            // relaunching in a new tab when returning from the Venmo app. This can
            // be omitted otherwise.
            allowNewBrowserTab: false,
          })
          .then((venmoInstance) => {
            // Verify browser support before proceeding.
            if (!venmoInstance?.isBrowserSupported()) {
              reject('Browser does not support Venmo');
              return;
            } else {
              resolve(venmoInstance);
            }

            // Check if tokenization results already exist. This occurs when your
            // checkout page is relaunched in a new tab. This step can be omitted
            // if allowNewBrowserTab is false.
            // if (venmoInstance.hasTokenizationResult()) {
            //   venmoInstance
            //     .tokenize({})
            //     .then((payload) => {
            //       if (payload) {
            //         //   handleVenmoError(tokenizeErr);
            //       } else {
            //         //   handleVenmoSuccess(payload);
            //       }
            //     })
            //     .catch(reject);
            // }
          })
          .catch(reject);
      })
      .catch(reject);
  });
}

function createBraintreeDataCollector(braintreePK: string): Promise<braintree.DataCollector> {
  return new Promise((resolve, reject) => {
    braintree.client
      .create({
        authorization: braintreePK,
      })
      .then((clientInstance) => {
        braintree.dataCollector
          .create({ client: clientInstance, paypal: true })
          .then(resolve)
          .catch(reject);
      })
      .catch(reject);
  });
}

async function createClientInstance(braintreePK: string) {
  return new Promise<braintree.Client>((resolve, reject) => {
    braintree.client
      .create({
        authorization: braintreePK,
      })
      .then(resolve)
      .catch(reject);
  });
}

interface InitBraintreeHostedFieldsParams {
  clientInstance: braintree.Client;
  cardNumberContainer: HTMLElement;
  securityCodeContainer: HTMLElement;
  expirationDateContainer: HTMLElement;
}

async function createHostedFields({
  clientInstance,
  cardNumberContainer,
  securityCodeContainer,
  expirationDateContainer,
}: InitBraintreeHostedFieldsParams) {
  return new Promise<hostedFields.HostedFields>((resolve, reject) => {
    hostedFields
      .create({
        client: clientInstance,
        styles: { input: { 'font-size': '16px', color: '#3a3a3a' } },
        fields: {
          number: {
            container: cardNumberContainer,
            placeholder: 'Card Number',
          },
          cvv: {
            container: securityCodeContainer,
            placeholder: 'CVC',
          },
          expirationDate: {
            container: expirationDateContainer,
            placeholder: 'MM / YY',
          },
        },
      })
      .then((hostedFieldsInstance) => {
        resolve(hostedFieldsInstance);
      })
      .catch(() => {
        reject('Failed to initialize Braintree Hosted Fields');
      });
  });
}

async function createThreeDSecure(clientInstance: braintree.Client) {
  return new Promise<braintree.ThreeDSecure>((resolve, reject) => {
    braintree.threeDSecure
      .create({ client: clientInstance, version: 2 })
      .then(resolve)
      .catch(reject);
  });
}

export const braintreeService = {
  createVenmoClient,
  createThreeDSecure,
  createHostedFields,
  createClientInstance,
  createBraintreeDataCollector,
};
